import Helpers from './helpers'

var events = {
  onInvoiceUploaded: new Event('onInvoiceUploaded'),
  onBarCodeReaderSuccess: new Event('onBarCodeReaderSuccess'),
  onGetDeviceInfo: new Event('onGetDeviceInfo'),
  onBarCodeReaderError: new Event('onBarCodeReaderError'),
  onGetSessionId: new Event('onGetSessionId'),
  onSetSessionId: new Event('onSetSessionId'),
  onInternetFail: new Event('onInternetFail'),
  onInternetReturn: new Event('onInternetReturn'),
  onOpenApp: new Event('onOpenApp')
}

var MobileApi = {
  device: null,
  counterBack: 0,
  Store: {},
  callbackInvoice: null,
  setDevice: function () {
    this.device = Helpers.getOS()
  },
  setStore: function (Store) {
    this.Store = Store
  },
  openBarCodeReader: function () {
    if (this.device === "iOS") {
      webkit.messageHandlers.IOS.postMessage('{"action": "openBarCodeReader"}');
    } else {
      Android.openBarCodeReader();
    }
  },
  openUrl: function (url) {
    if (this.device === "iOS") {
      webkit.messageHandlers.IOS.postMessage('{"action": "openUrl", "url" : "' + url + '"}');
    } else {
      Android.openUrl(url);
    }
  },
  getSessionId: function () {
    if (this.device === "iOS") {
      webkit.messageHandlers.IOS.postMessage('{"action": "getSessionId"}');
    } else {
      Android.getSessionId();
    }
  },
  setSessionId: function (User) {
    if (this.device === "iOS") {
      webkit.messageHandlers.IOS.postMessage('{"action": "setSessionId", "sessionId": "' + User + '"}');
    } else {
      Android.setSessionId(User);
    }

  },
  getDeviceInfo: function () {
    if (this.device === "iOS") {
      webkit.messageHandlers.IOS.postMessage('{"action": "getDeviceInfo"}');
    } else {
      Android.getDeviceInfo();
    }
  },
  backBtnPressed: function () {
    var pages = document.getElementsByClassName("back");
    if (pages.length > 0) {
      for (var i = 0; i < pages.length; i++) {
        pages[i].click();
      }
      this.counterBack = 0;
    } else {
      this.counterBack++;
      if (this.counterBack >= 2) {
        this.closeApp();
      } else {
        setTimeout(function () {
          MobileApi.counterBack = 0;
        }, 500);
      }
    }

  },
  signOut: function () {
    if (this.device === "iOS") {
      webkit.messageHandlers.IOS.postMessage('{"action": "signOut"}');
    } else {
      Android.signOut();
    }
  },
  closeApp: function () {
    if (this.device === "iOS") {
      webkit.messageHandlers.IOS.postMessage('{"action": "closeApp"}');
    } else {
      Android.closeApp();
    }
  },
  uploadInvoice: function (url, gia, packid, clientId, callback) {
    this.callbackInvoice = callback;
    if (this.device === "iOS") {
      webkit.messageHandlers.IOS.postMessage('{"action": "uploadInvoice", "photoUrl": "' + url + '", "guiaNo": "' + gia + '", "trackingNo": "' + packid + '", "clientId": "' + clientId + '"}');
    } else {
      Android.uploadInvoice(url, gia, packid, clientId);
    }

  },
  openLocationInMap: function (log, lat, title) {
    if (this.device === "iOS") {
      webkit.messageHandlers.IOS.postMessage('{"action": "openLocationInMap", "longitud": "' + log + '", "latitud": "' + lat + '", "officeLabel": "' + title + '"}');
    } else {
      Android.openLocationInMap(log, lat, title);
    }

  },
  onBarCodeReaderSuccess: function (code) {
    window.dispatchEvent(events.onBarCodeReaderSuccess, {
      code: code
    })
  },
  onGetDeviceInfo: function (brand, model) {
    window.dispatchEvent(events.onGetDeviceInfo, {
      brand,
      model
    })
  },
  onBarCodeReaderError: function (data) {
    window.dispatchEvent(events.onBarCodeReaderError, {
      error: data
    })
  },
  onGetSessionId: function (userName, pushId) {

    console.log("onGetSessionId -----> " + " userName : " + userName + " pushId : " + pushId);
    if (userName === "" || userName === null || userName === "null" || userName === undefined) {
      this.Store.dispatch('login', false);
    } else {
      this.Store.dispatch('login', true);
      this.Store.dispatch('setUser', {
        userName: userName,
        pushId: pushId
      })
    }

  },
  onSetSessionId: function (userName, pushId) {

    console.log("onSetSessionId -----> " + " userName : " + userName + " pushId : " + pushId);
    if (userName === "" || userName === null || userName === "null" || userName === undefined) {
      this.Store.dispatch('login', false);
    } else {
      this.Store.dispatch('login', true);
      this.Store.dispatch('setUser', {
        userName: userName,
        pushId: pushId
      })
    }

  },
  onInternetFail: function () {
    window.dispatchEvent(events.onInternetFail)
  },
  onInternetReturn: function () {
    window.dispatchEvent(events.onInternetReturn)
  },
  onOpenApp: function (data) {
    window.dispatchEvent(events.onOpenApp)
  },
  onInvoiceUploaded: function (data) {
    this.Store.dispatch('showUploadFile', true);
    window.dispatchEvent(events.onInvoiceUploaded)
    if (this.callbackInvoice != null) {
      this.callbackInvoice();
    }
  }
}
window.MobileApi = MobileApi

export default MobileApi;